const countryDialCodes = [
  { iso: 'AF', name: 'Afghanistan', dialCode: '+93' },
  { iso: 'AL', name: 'Albanie', dialCode: '+355' },
  { iso: 'DZ', name: 'Algérie', dialCode: '+213' },
  { iso: 'AS', name: 'Samoa américaines', dialCode: '+1684' },
  { iso: 'AD', name: 'Andorre', dialCode: '+376' },
  { iso: 'AO', name: 'Angola', dialCode: '+244' },
  { iso: 'AI', name: 'Anguilla', dialCode: '+1264' },
  { iso: 'AG', name: 'Antigua-et-Barbuda', dialCode: '+1268' },
  { iso: 'AR', name: 'Argentine', dialCode: '+54' },
  { iso: 'AM', name: 'Arménie', dialCode: '+374' },
  { iso: 'AW', name: 'Aruba', dialCode: '+297' },
  { iso: 'AU', name: 'Australie', dialCode: '+61' },
  { iso: 'AT', name: 'Autriche', dialCode: '+43' },
  { iso: 'AZ', name: 'Azerbaïdjan', dialCode: '+994' },
  { iso: 'BS', name: 'Bahamas', dialCode: '+1242' },
  { iso: 'BH', name: 'Bahreïn', dialCode: '+973' },
  { iso: 'BD', name: 'Bangladesh', dialCode: '+880' },
  { iso: 'BB', name: 'Barbade', dialCode: '+1246' },
  { iso: 'BY', name: 'Biélorussie', dialCode: '+375' },
  { iso: 'BE', name: 'Belgique', dialCode: '+32' },
  { iso: 'BZ', name: 'Belize', dialCode: '+501' },
  { iso: 'BJ', name: 'Bénin', dialCode: '+229' },
  { iso: 'BM', name: 'Bermudes', dialCode: '+1441' },
  { iso: 'BT', name: 'Bhoutan', dialCode: '+975' },
  { iso: 'BO', name: 'Bolivie', dialCode: '+591' },
  { iso: 'BA', name: 'Bosnie-Herzégovine', dialCode: '+387' },
  { iso: 'BW', name: 'Botswana', dialCode: '+267' },
  { iso: 'BR', name: 'Brésil', dialCode: '+55' },
  { iso: 'VG', name: 'Îles Vierges britanniques', dialCode: '+1284' },
  { iso: 'BN', name: 'Brunei', dialCode: '+673' },
  { iso: 'BG', name: 'Bulgarie', dialCode: '+359' },
  { iso: 'BF', name: 'Burkina Faso', dialCode: '+226' },
  { iso: 'BI', name: 'Burundi', dialCode: '+257' },
  { iso: 'KH', name: 'Cambodge', dialCode: '+855' },
  { iso: 'CM', name: 'Cameroun', dialCode: '+237' },
  { iso: 'CA', name: 'Canada', dialCode: '+1' },
  { iso: 'CV', name: 'Cap-Vert', dialCode: '+238' },
  { iso: 'BQ', name: 'Caraïbes néerlandaises', dialCode: '+599' },
  { iso: 'KY', name: 'Îles Caïmans', dialCode: '+1345' },
  { iso: 'CF', name: 'République centrafricaine', dialCode: '+236' },
  { iso: 'TD', name: 'Tchad', dialCode: '+235' },
  { iso: 'CL', name: 'Chili', dialCode: '+56' },
  { iso: 'CN', name: 'Chine', dialCode: '+86' },
  { iso: 'CX', name: 'Île Christmas', dialCode: '+61' },
  { iso: 'CO', name: 'Colombie', dialCode: '+57' },
  { iso: 'KM', name: 'Comores', dialCode: '+269' },
  { iso: 'CG', name: 'Congo (Brazzaville)', dialCode: '+242' },
  { iso: 'CD', name: 'Congo (Kinshasa)', dialCode: '+243' },
  { iso: 'CK', name: 'Îles Cook', dialCode: '+682' },
  { iso: 'CR', name: 'Costa Rica', dialCode: '+506' },
  { iso: 'CI', name: "Côte d'Ivoire", dialCode: '+225' },
  { iso: 'HR', name: 'Croatie', dialCode: '+385' },
  { iso: 'CU', name: 'Cuba', dialCode: '+53' },
  { iso: 'CY', name: 'Chypre', dialCode: '+357' },
  { iso: 'CZ', name: 'Tchéquie', dialCode: '+420' },
  { iso: 'DK', name: 'Danemark', dialCode: '+45' },
  { iso: 'DJ', name: 'Djibouti', dialCode: '+253' },
  { iso: 'DM', name: 'Dominique', dialCode: '+1767' },
  { iso: 'DO', name: 'République dominicaine', dialCode: '+1809' },
  { iso: 'EC', name: 'Équateur', dialCode: '+593' },
  { iso: 'EG', name: 'Égypte', dialCode: '+20' },
  { iso: 'SV', name: 'Salvador', dialCode: '+503' },
  { iso: 'GQ', name: 'Guinée équatoriale', dialCode: '+240' },
  { iso: 'ER', name: 'Érythrée', dialCode: '+291' },
  { iso: 'EE', name: 'Estonie', dialCode: '+372' },
  { iso: 'SZ', name: 'Eswatini', dialCode: '+268' },
  { iso: 'ET', name: 'Éthiopie', dialCode: '+251' },
  { iso: 'FK', name: 'Îles Falkland', dialCode: '+500' },
  { iso: 'FO', name: 'Îles Féroé', dialCode: '+298' },
  { iso: 'FJ', name: 'Fidji', dialCode: '+679' },
  { iso: 'FI', name: 'Finlande', dialCode: '+358' },
  { iso: 'FR', name: 'France', dialCode: '+33' },
  { iso: 'GF', name: 'Guyane française', dialCode: '+594' },
  { iso: 'PF', name: 'Polynésie française', dialCode: '+689' },
  { iso: 'GA', name: 'Gabon', dialCode: '+241' },
  { iso: 'GM', name: 'Gambie', dialCode: '+220' },
  { iso: 'GE', name: 'Géorgie', dialCode: '+995' },
  { iso: 'DE', name: 'Allemagne', dialCode: '+49' },
  { iso: 'GH', name: 'Ghana', dialCode: '+233' },
  { iso: 'GI', name: 'Gibraltar', dialCode: '+350' },
  { iso: 'GR', name: 'Grèce', dialCode: '+30' },
  { iso: 'GL', name: 'Groenland', dialCode: '+299' },
  { iso: 'GD', name: 'Grenade', dialCode: '+1473' },
  { iso: 'GP', name: 'Guadeloupe', dialCode: '+590' },
  { iso: 'GU', name: 'Guam', dialCode: '+1671' },
  { iso: 'GT', name: 'Guatemala', dialCode: '+502' },
  { iso: 'GG', name: 'Guernesey', dialCode: '+44' },
  { iso: 'GN', name: 'Guinée', dialCode: '+224' },
  { iso: 'GW', name: 'Guinée-Bissau', dialCode: '+245' },
  { iso: 'GY', name: 'Guyana', dialCode: '+592' },
  { iso: 'HT', name: 'Haïti', dialCode: '+509' },
  { iso: 'HN', name: 'Honduras', dialCode: '+504' },
  { iso: 'HK', name: 'Hong Kong', dialCode: '+852' },
  { iso: 'HU', name: 'Hongrie', dialCode: '+36' },
  { iso: 'IS', name: 'Islande', dialCode: '+354' },
  { iso: 'IN', name: 'Inde', dialCode: '+91' },
  { iso: 'ID', name: 'Indonésie', dialCode: '+62' },
  { iso: 'IR', name: 'Iran', dialCode: '+98' },
  { iso: 'IQ', name: 'Irak', dialCode: '+964' },
  { iso: 'IE', name: 'Irlande', dialCode: '+353' },
  { iso: 'IM', name: 'Île de Man', dialCode: '+44' },
  { iso: 'IL', name: 'Israël', dialCode: '+972' },
  { iso: 'IT', name: 'Italie', dialCode: '+39' },
  { iso: 'JM', name: 'Jamaïque', dialCode: '+1876' },
  { iso: 'JP', name: 'Japon', dialCode: '+81' },
  { iso: 'JE', name: 'Jersey', dialCode: '+44' },
  { iso: 'JO', name: 'Jordanie', dialCode: '+962' },
  { iso: 'KZ', name: 'Kazakhstan', dialCode: '+7' },
  { iso: 'KE', name: 'Kenya', dialCode: '+254' },
  { iso: 'KI', name: 'Kiribati', dialCode: '+686' },
  { iso: 'XK', name: 'Kosovo', dialCode: '+383' },
  { iso: 'KW', name: 'Koweït', dialCode: '+965' },
  { iso: 'KG', name: 'Kirghizistan', dialCode: '+996' },
  { iso: 'LA', name: 'Laos', dialCode: '+856' },
  { iso: 'LV', name: 'Lettonie', dialCode: '+371' },
  { iso: 'LB', name: 'Liban', dialCode: '+961' },
  { iso: 'LS', name: 'Lesotho', dialCode: '+266' },
  { iso: 'LR', name: 'Libéria', dialCode: '+231' },
  { iso: 'LY', name: 'Libye', dialCode: '+218' },
  { iso: 'LI', name: 'Liechtenstein', dialCode: '+423' },
  { iso: 'LT', name: 'Lituanie', dialCode: '+370' },
  { iso: 'LU', name: 'Luxembourg', dialCode: '+352' },
  { iso: 'MO', name: 'Macao', dialCode: '+853' },
  { iso: 'MG', name: 'Madagascar', dialCode: '+261' },
  { iso: 'MW', name: 'Malawi', dialCode: '+265' },
  { iso: 'MY', name: 'Malaisie', dialCode: '+60' },
  { iso: 'MV', name: 'Maldives', dialCode: '+960' },
  { iso: 'ML', name: 'Mali', dialCode: '+223' },
  { iso: 'MT', name: 'Malte', dialCode: '+356' },
  { iso: 'MH', name: 'Îles Marshall', dialCode: '+692' },
  { iso: 'MQ', name: 'Martinique', dialCode: '+596' },
  { iso: 'MR', name: 'Mauritanie', dialCode: '+222' },
  { iso: 'MU', name: 'Maurice', dialCode: '+230' },
  { iso: 'YT', name: 'Mayotte', dialCode: '+262' },
  { iso: 'MX', name: 'Mexique', dialCode: '+52' },
  { iso: 'FM', name: 'Micronésie', dialCode: '+691' },
  { iso: 'MD', name: 'Moldavie', dialCode: '+373' },
  { iso: 'MC', name: 'Monaco', dialCode: '+377' },
  { iso: 'MN', name: 'Mongolie', dialCode: '+976' },
  { iso: 'ME', name: 'Monténégro', dialCode: '+382' },
  { iso: 'MS', name: 'Montserrat', dialCode: '+1664' },
  { iso: 'MA', name: 'Maroc', dialCode: '+212' },
  { iso: 'MZ', name: 'Mozambique', dialCode: '+258' },
  { iso: 'MM', name: 'Myanmar', dialCode: '+95' },
  { iso: 'NA', name: 'Namibie', dialCode: '+264' },
  { iso: 'NR', name: 'Nauru', dialCode: '+674' },
  { iso: 'NP', name: 'Népal', dialCode: '+977' },
  { iso: 'NL', name: 'Pays-Bas', dialCode: '+31' },
  { iso: 'NC', name: 'Nouvelle-Calédonie', dialCode: '+687' },
  { iso: 'NZ', name: 'Nouvelle-Zélande', dialCode: '+64' },
  { iso: 'NI', name: 'Nicaragua', dialCode: '+505' },
  { iso: 'NE', name: 'Niger', dialCode: '+227' },
  { iso: 'NG', name: 'Nigéria', dialCode: '+234' },
  { iso: 'NU', name: 'Niue', dialCode: '+683' },
  { iso: 'NF', name: 'Île Norfolk', dialCode: '+672' },
  { iso: 'KP', name: 'Corée du Nord', dialCode: '+850' },
  { iso: 'MK', name: 'Macédoine du Nord', dialCode: '+389' },
  { iso: 'MP', name: 'Îles Mariannes du Nord', dialCode: '+1670' },
  { iso: 'NO', name: 'Norvège', dialCode: '+47' },
  { iso: 'OM', name: 'Oman', dialCode: '+968' },
  { iso: 'PK', name: 'Pakistan', dialCode: '+92' },
  { iso: 'PW', name: 'Palaos', dialCode: '+680' },
  { iso: 'PS', name: 'Palestine', dialCode: '+970' },
  { iso: 'PA', name: 'Panama', dialCode: '+507' },
  { iso: 'PG', name: 'Papouasie-Nouvelle-Guinée', dialCode: '+675' },
  { iso: 'PY', name: 'Paraguay', dialCode: '+595' },
  { iso: 'PE', name: 'Pérou', dialCode: '+51' },
  { iso: 'PH', name: 'Philippines', dialCode: '+63' },
  { iso: 'PL', name: 'Pologne', dialCode: '+48' },
  { iso: 'PT', name: 'Portugal', dialCode: '+351' },
  { iso: 'PR', name: 'Porto Rico', dialCode: '+1787' },
  { iso: 'QA', name: 'Qatar', dialCode: '+974' },
  { iso: 'RE', name: 'La Réunion', dialCode: '+262' },
  { iso: 'RO', name: 'Roumanie', dialCode: '+40' },
  { iso: 'RU', name: 'Russie', dialCode: '+7' },
  { iso: 'RW', name: 'Rwanda', dialCode: '+250' },
  { iso: 'BL', name: 'Saint-Barthélemy', dialCode: '+590' },
  { iso: 'SH', name: 'Sainte-Hélène', dialCode: '+290' },
  { iso: 'KN', name: 'Saint-Kitts-et-Nevis', dialCode: '+1869' },
  { iso: 'LC', name: 'Sainte-Lucie', dialCode: '+1758' },
  { iso: 'MF', name: 'Saint-Martin', dialCode: '+590' },
  { iso: 'PM', name: 'Saint-Pierre-et-Miquelon', dialCode: '+508' },
  { iso: 'VC', name: 'Saint-Vincent-et-les-Grenadines', dialCode: '+1784' },
  { iso: 'WS', name: 'Samoa', dialCode: '+685' },
  { iso: 'SM', name: 'Saint-Marin', dialCode: '+378' },
  { iso: 'ST', name: 'Sao Tomé-et-Principe', dialCode: '+239' },
  { iso: 'SA', name: 'Arabie saoudite', dialCode: '+966' },
  { iso: 'SN', name: 'Sénégal', dialCode: '+221' },
  { iso: 'RS', name: 'Serbie', dialCode: '+381' },
  { iso: 'SC', name: 'Seychelles', dialCode: '+248' },
  { iso: 'SL', name: 'Sierra Leone', dialCode: '+232' },
  { iso: 'SG', name: 'Singapour', dialCode: '+65' },
  { iso: 'SK', name: 'Slovaquie', dialCode: '+421' },
  { iso: 'SI', name: 'Slovénie', dialCode: '+386' },
  { iso: 'SB', name: 'Îles Salomon', dialCode: '+677' },
  { iso: 'SO', name: 'Somalie', dialCode: '+252' },
  { iso: 'ZA', name: 'Afrique du Sud', dialCode: '+27' },
  { iso: 'GS', name: 'Géorgie du Sud-et-les îles Sandwich du Sud', dialCode: '+500' },
  { iso: 'KR', name: 'Corée du Sud', dialCode: '+82' },
  { iso: 'SS', name: 'Soudan du Sud', dialCode: '+211' },
  { iso: 'ES', name: 'Espagne', dialCode: '+34' },
  { iso: 'LK', name: 'Sri Lanka', dialCode: '+94' },
  { iso: 'SD', name: 'Soudan', dialCode: '+249' },
  { iso: 'SR', name: 'Suriname', dialCode: '+597' },
  { iso: 'SJ', name: 'Svalbard et Jan Mayen', dialCode: '+47' },
  { iso: 'SE', name: 'Suède', dialCode: '+46' },
  { iso: 'CH', name: 'Suisse', dialCode: '+41' },
  { iso: 'SY', name: 'Syrie', dialCode: '+963' },
  { iso: 'TW', name: 'Taïwan', dialCode: '+886' },
  { iso: 'TJ', name: 'Tadjikistan', dialCode: '+992' },
  { iso: 'TZ', name: 'Tanzanie', dialCode: '+255' },
  { iso: 'TH', name: 'Thaïlande', dialCode: '+66' },
  { iso: 'TL', name: 'Timor oriental', dialCode: '+670' },
  { iso: 'TG', name: 'Togo', dialCode: '+228' },
  { iso: 'TK', name: 'Tokelau', dialCode: '+690' },
  { iso: 'TO', name: 'Tonga', dialCode: '+676' },
  { iso: 'TT', name: 'Trinité-et-Tobago', dialCode: '+1868' },
  { iso: 'TN', name: 'Tunisie', dialCode: '+216' },
  { iso: 'TR', name: 'Turquie', dialCode: '+90' },
  { iso: 'TM', name: 'Turkménistan', dialCode: '+993' },
  { iso: 'TC', name: 'Îles Turques-et-Caïques', dialCode: '+1649' },
  { iso: 'TV', name: 'Tuvalu', dialCode: '+688' },
  { iso: 'UG', name: 'Ouganda', dialCode: '+256' },
  { iso: 'UA', name: 'Ukraine', dialCode: '+380' },
  { iso: 'AE', name: 'Émirats arabes unis', dialCode: '+971' },
  { iso: 'GB', name: 'Royaume-Uni', dialCode: '+44' },
  { iso: 'US', name: 'États-Unis', dialCode: '+1' },
  { iso: 'UY', name: 'Uruguay', dialCode: '+598' },
  { iso: 'UZ', name: 'Ouzbékistan', dialCode: '+998' },
  { iso: 'VU', name: 'Vanuatu', dialCode: '+678' },
  { iso: 'VA', name: 'Vatican', dialCode: '+379' },
  { iso: 'VE', name: 'Venezuela', dialCode: '+58' },
  { iso: 'VN', name: 'Vietnam', dialCode: '+84' },
  { iso: 'WF', name: 'Wallis-et-Futuna', dialCode: '+681' },
  { iso: 'EH', name: 'Sahara occidental', dialCode: '+212' },
  { iso: 'YE', name: 'Yémen', dialCode: '+967' },
  { iso: 'ZM', name: 'Zambie', dialCode: '+260' },
  { iso: 'ZW', name: 'Zimbabwe', dialCode: '+263' }
];

export default countryDialCodes;
